import React, { useState } from "react";
import { API } from "@/lib/api";
import * as Icons from "lucide-react";

const STEPS = [
  "Download the helper (Download FUB Helper Extension button).",
  "Unzip it.",
  "Open chrome://extensions in Chrome.",
  "Enable Developer Mode (top-right toggle).",
  "Click Load Unpacked.",
  "Select the extracted FUB-Catalog-Helper folder.",
  "Log into Follow Up Boss normally.",
  "Open the helper (puzzle icon → FUB Catalog Helper), paste the connect token once, then click Connect.",
];

export const HelperSetup = ({ approvedNames }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="mt-5 border-t border-stone-200 pt-4" data-testid="helper-setup">
      <div className="flex items-center gap-3 flex-wrap">
        <a href={`${API}/extension/download`} download="FUB-Catalog-Helper.zip" data-testid="download-helper-btn"
          className="inline-flex items-center gap-2 px-4 py-2 text-sm bg-stone-900 text-white rounded-lg hover:bg-stone-700">
          <Icons.Download className="w-4 h-4" /> Download FUB Helper Extension
        </a>
        <button onClick={() => setOpen(!open)} data-testid="toggle-setup-instructions"
          className="text-sm text-stone-500 hover:text-stone-800 inline-flex items-center gap-1">
          <Icons.ChevronDown className={`w-4 h-4 transition-transform ${open ? "" : "-rotate-90"}`} /> First-time setup
        </button>
      </div>
      {open && (
        <div className="mt-3 text-sm text-stone-700" data-testid="setup-instructions">
          <ol className="list-decimal pl-5 space-y-1">{STEPS.map((s) => <li key={s}>{s}</li>)}</ol>
          {approvedNames === 0 && (
            <div className="mt-3 bg-amber-50 border border-amber-200 rounded-lg p-3 text-xs text-amber-800" data-testid="discovery-notice">
              <b>Discovery phase:</b> no session cookie names are approved yet, so the first Connect only displays the
              cookie <b>names</b> set on the FUB account host. No cookie values are sent to the Catalog.
            </div>
          )}
          <p className="text-xs text-stone-400 mt-2">The download contains only the extension files — no token, session, or server credentials.</p>
        </div>
      )}
    </div>
  );
};
